import { ProviderRepo } from "../fileprovider.repo";
import * as _ from "lodash";
import { FileItem } from "../FileItem";

class fileInfoController implements angular.IOnInit {
  public selectedUsername: string;
  public password: string;
  public isLoading = false;
  public showpassword = false;
  public file: FileItem;

  /** @ngInject */
  constructor(
    private providerRepo: ProviderRepo,
    private $state: angular.ui.IStateService,
    private $stateParams: angular.ui.IStateParamsService,
    private notifyjs: any
  ) {}

  $onInit() {
    var username = this.$stateParams["username"];
    if (!username) {
      this.notifyjs("No File Id was supplied");
      return;
    }

    this.isLoading = true;
    this.providerRepo
      .getPassword(username)
      .then((val) => {
        this.selectedUsername = username;
        this.file = val as FileItem;
      })
      .catch((err) => this.notifyjs(err))
      .finally(() => (this.isLoading = false));
  }

  saveFile() {
    this.isLoading = true;
    this.providerRepo
      .saveFile(this.selectedUsername, this.file)
      .catch((err) => this.notifyjs(err))
      .finally(() => {
        this.isLoading = false;
        this.selectedUsername = undefined;
        this.password = "";
        this.file = null;
        this.$state.go("root.fileproviders");
      });
  }

  //TODO: Implement cancel/back button
  cancelFileEdit() {
    this.selectedUsername = undefined;
    this.password = "";
    this.$state.go("root.fileproviders");
  }
}

export const fileInfo: angular.IComponentOptions = {
  template: require("./fileInfo.html"),
  controller: fileInfoController,
  bindings: {
    selectedUsername: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/fileprovider/viewFile/fileInfo.ts